import { products } from '@/shared/config/products';

export default {
  methods: {
    getProductNameById(id, transform = null) {
      let name = products?.find((product) => product.id === id)?.label || '';

      switch (transform) {
        case 'uppercase':
          return name.toUpperCase();
        case 'lowercase':
          return name.toLowerCase();
        case 'capitalize':
          return name.replace(/\b\w/g, c => c.toUpperCase());
        default:
          return name;
      }
    },
  }
};
